import Share from './share'

export default Share
